import React, {Component} from 'react';
import {connect} from 'react-redux';
import {findIndex} from 'lodash';
import {Card} from 'semantic-ui-react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import {colors} from '../../../../common/constants/colors';
import './setSaleChart.scss';

class barChartSetSales extends Component {
  renderCustomerBar(listDealerId) {
    return listDealerId.map((element, index) => {
      return (
        <Bar key={index} dataKey= {element.customerId} fill={colors[index]} name={element.customerName} />
      );
    });
  }

  procesData() {
    const {setSalesList} = this.props;
    const listDealerId = [];
    const listSetData = [];
     
    setSalesList.forEach((element) => {
      const existDealer = findIndex(listDealerId, {'customerId': element.customerId});
      if (existDealer === -1) {
        listDealerId.push({'customerId': element.customerId, 'customerName': element.customerName});
      }
      const existSetCode = findIndex(listSetData, {'setCode': element.setCode});
      if (existSetCode === -1) {
        const newSetCode = {'setCode': element.setCode};
        newSetCode[element.customerId] = element.total;
        listSetData.push(newSetCode);
      } else {
        listSetData[existSetCode][element.customerId] = element.total;
      }
    });
    return {listDealerId, listSetData};
  }

  render() {
    const objectSetSales = this.procesData();
    if (objectSetSales.listSetData.length === 0) {
      return null;
    }
    return (
      <Card fluid raised>
        <div className ='set-sales-chart-container' >
          <BarChart width={20000} height={300} data={objectSetSales.listSetData} barSize={40}
            margin={{'top': 20, 'right': 30, 'left': 20, 'bottom': 15}}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey='setCode'/>
            <YAxis/>
            <Tooltip/>
            <Legend />
            {this.renderCustomerBar(objectSetSales.listDealerId)}
          </BarChart>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'setSalesList': state.setsHeadSales.list,
  };
};

export default connect(mapStateToProps, {
})(barChartSetSales);
